module.exports = __webpack_public_path__ + "img/anke-easy-yoga.60a4ea28.jpg";